import React from "react";
import './Header.css';

function Header() {
    return(
        <>
    <div className="navbarr d-lg-block d-md-block d-sm-none d-none bg-secondary sticky-top">
        <div className="container">
            <div className=" d-lg-flex d-md-flex  flex-lg-row flex-md-column flex-sm-column ">
                <div className=" mt-1 col-lg-6 col-md-6 col-sm-6 logo p-lg-3 p-md-3 p-sm-0 text-white text-center fs-3 font-monospace" href="#home">ShwapnoNirman.com</div>
            <div className="col-lg-6 d-flex flex-lg-row flex-md-row flex-sm-column col-md-6 col-sm-6 home text-center p-lg-4 p-md-4 p-sm-0 fs-6 fw-bold">
                <div className="p-2  text-light text-uppercase corsur" href="#home">Home</div>
                <div className="p-2 text-light text-uppercase corsur" href="#link">About</div>
                <div className="p-2 text-light text-uppercase corsur" href="#link">Blog</div>
                <div className="p-2 text-light text-uppercase corsur" href="#link">Contact</div>
                <div className="p-2 text-light text-uppercase corsur" href="#link">Services</div>
            </div>
            </div>
        </div>
    </div>
        </>
    )
}

export default Header;